import type { ComponentType } from "react";

import type { Role } from "@/models/user.ts";
import { AuthGuard } from "@/route-guards/auth-guard.tsx";

export function withAuthGuard(roles: Role[]): <P extends object>(Component: ComponentType<P>) => ComponentType<P> {
    return function <P extends object>(Component: ComponentType<P>) {
        return function GuardedComponent(props: P) {
            return (
                <AuthGuard roles={roles}>
                    <Component {...props} />
                </AuthGuard>
            );
        };
    };
}
